<template>
  <div class="container skeleton" data-testid="skeleton-module">
    <Selector>
      <template slot="desktop">
        <div class="offers-revamp-skeleton">
        <content-loader
        class="mb-4"
          viewBox="0 0 500 500"
          primaryColor="#f3f3f3"
          secondaryColor="#dedede"
        >
            <rect x="0" y="0" rx="5" ry="5" width="130" height="100" />
            <rect x="135" y="0" rx="5" ry="5" width="130" height="100" />
            <rect x="270" y="0" rx="5" ry="5" width="130" height="100" />

            <rect x="100" y="105" rx="5" ry="5" width="200" height="20" />

        </content-loader>
        <content-loader viewBox="0 0 0 0" :speed="2" primaryColor="#f3f3f3" secondaryColor="#dedede">
          <rect x="0" y="0" rx="5" ry="5" width="97" height="84"/>
          <rect x="5" y="91" rx="5" ry="5" width="87" height="9" />
          <rect x="5" y="116" rx="5" ry="5" width="87" height="9" />

          <rect x="101" y="0" rx="5" ry="5" width="97" height="84"/>
          <rect x="106" y="91" rx="5" ry="5" width="87" height="9" />
          <rect x="106" y="116" rx="5" ry="5" width="87" height="9" />

          <rect x="202" y="0" rx="5" ry="5" width="97" height="84"/>
          <rect x="207" y="91" rx="5" ry="5" width="87" height="9" />
          <rect x="207" y="116" rx="5" ry="5" width="87" height="9" />

          <rect x="303" y="0" rx="5" ry="5" width="97" height="84"/>
          <rect x="308" y="91" rx="5" ry="5" width="87" height="9" />
          <rect x="308" y="116" rx="5" ry="5" width="87" height="9" />
        </content-loader>
        <content-loader viewBox="0 0 0 0" :speed="2" primaryColor="#f3f3f3" secondaryColor="#dedede">
          <rect x="0" y="0" rx="5" ry="5" width="97" height="84"/>
          <rect x="5" y="91" rx="5" ry="5" width="87" height="9" />
          <rect x="5" y="116" rx="5" ry="5" width="87" height="9" />

          <rect x="101" y="0" rx="5" ry="5" width="97" height="84"/>
          <rect x="106" y="91" rx="5" ry="5" width="87" height="9" />
          <rect x="106" y="116" rx="5" ry="5" width="87" height="9" />

          <rect x="202" y="0" rx="5" ry="5" width="97" height="84"/>
          <rect x="207" y="91" rx="5" ry="5" width="87" height="9" />
          <rect x="207" y="116" rx="5" ry="5" width="87" height="9" />

          <rect x="303" y="0" rx="5" ry="5" width="97" height="84"/>
          <rect x="308" y="91" rx="5" ry="5" width="87" height="9" />
          <rect x="308" y="116" rx="5" ry="5" width="87" height="9" />
        </content-loader>
      </div>

      </template>
    </Selector>
    <Selector>
      <template slot="mobile">
        <div class="offers-revamp-skeleton">
          <content-loader
            viewBox="0 0 400 480"
            :speed="2"
            primaryColor="#f3f3f3"
            secondaryColor="#ecebeb"
          >
          <rect x="0" y="0" rx="5" ry="5" width="100%" height="100" />
          </content-loader>
          <content-loader
            viewBox="0 0 0 0"
            :speed="2"
            primaryColor="#f3f3f3"
            secondaryColor="#ecebeb"
          >
            <rect x="0" y="0" rx="30" ry="35" width="150" height="50" />
            <rect x="160" y="0" rx="30" ry="35" width="150" height="50" />
            <rect x="330" y="0" rx="30" ry="35" width="150" height="50" />

            <rect x="0" y="70" rx="30" ry="35" width="150" height="50" />
            <rect x="160" y="70" rx="30" ry="35" width="150" height="50" />
            <rect x="330" y="70" rx="30" ry="35" width="150" height="50" />
          </content-loader>
          <content-loader
            height="300"
            :speed="2"
            primaryColor="#f3f3f3"
            secondaryColor="#ecebeb"
          >
              <rect x="0" y="0" rx="5" ry="5" width="290" height="100%" />
              <rect x="300" y="0" rx="5" ry="5" width="100" height="100%" />
          </content-loader>
        </div>
      </template>
    </Selector>
  </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'
import Selector from '@/components/common/component-selector'

export default {
  name: 'OffersSliderSkeleton',
  components: {
    ContentLoader,
    Selector
  }
}
</script>
<style lang="scss" scoped>
.offers-revamp-skeleton {
  display: flex;
  flex-direction: column;
  gap: 4rem;
  margin-top: 4rem;
}
</style>
